/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./svg-icon.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./svg-icon.component";
import * as i3 from "./svg-icon.service";
var styles_UISvgIconComponent = [i0.styles];
var RenderType_UISvgIconComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_UISvgIconComponent, data: {} });
export { RenderType_UISvgIconComponent as RenderType_UISvgIconComponent };
export function View_UISvgIconComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_UISvgIconComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "svg-icon", [], null, null, null, View_UISvgIconComponent_0, RenderType_UISvgIconComponent)), i1.ɵdid(1, 114688, null, 0, i2.UISvgIconComponent, [i1.ElementRef, i3.UISvgIconService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var UISvgIconComponentNgFactory = i1.ɵccf("svg-icon", i2.UISvgIconComponent, View_UISvgIconComponent_Host_0, { src: "src", focusable: "focusable" }, {}, []);
export { UISvgIconComponentNgFactory as UISvgIconComponentNgFactory };
